import { makeContext } from './common/util/context';

export const [ApplicationTypeProvider, useApplicationType] = makeContext<'Support'|'Portal'>('Support');
